<template>
  <div class="app-container">
    <NavBar />
    <div class="app-main">
      <router-view />
    </div>
    <Footer />
    <!-- 回到顶部按钮 -->
    <el-backtop :bottom="100" :right="40" class="site-backtop">
      <i class="el-icon-top"></i>
    </el-backtop>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { getSiteConfig, getSiteConfigList } from '@/api/menu'

export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  created() {
    this.checkSiteConfigs()
  },
  mounted() {
    // 全局兜底：防止页面无接口请求或接口超时导致构建卡死
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'));
    }, 4000);
  },
  methods: {
    async checkSiteConfigs() {
      try {

        const result = await getSiteConfigList({ keys: 'site.showVisits,site.showExtData,site.map,site.footer,site.record,site.gray,site.logo,site.title,site.template,company.email,company.other,company.address,company.phone,company.qq,company.weixin,company.fax,site.description,site.keywords' })
        if (result.code === 0) {
          let data = result.data
          //1检查哀悼模式 (site.gray)
          if (data["site.gray"] === '1') {
            document.documentElement.classList.add('mourning-mode')
          } else {
            document.documentElement.classList.remove('mourning-mode')
          }

          // 2. 检查显示浏览量 (site.showVisits)
          this.$store.commit('setSiteConfig', { showVisits: data["site.showVisits"] })
          // 3. 检查显示外部数据 (site.showExtData)
          this.$store.commit('setSiteConfig', { showExtData: data["site.showExtData"] })
          // 4. 检查显示地图 (site.map)
          this.$store.commit('setSiteConfig', { showMap: data["site.map"] })
          // 5. 页脚信息 (site.footer)
          this.$store.commit('setSiteConfig', { showFooter: data["site.footer"] })
          // 6.站点备案信息 (site.record)
          this.$store.commit('setSiteConfig', { showRecord: data["site.record"] })
          // 7.网站logo信息 (site.logo)
          this.$store.commit('setSiteConfig', { showLogo: data["site.logo"] })
          //8站点标题（site.title）
          this.$store.commit('setSiteConfig', { showTitle: data["site.title"] })
          // 9.网站logo信息 (site.template)
          this.$store.commit('setSiteConfig', { showTemplate: data["site.template"] })
          // 10公司邮箱信息 (company.email)
          this.$store.commit('setSiteConfig', { showEmail: data["company.email"] })
          // 11工作时间 (company.other)
          this.$store.commit('setSiteConfig', { showOther: data["company.other"] })
          // 12公司地址信息 (company.address)
          this.$store.commit('setSiteConfig', { showAddress: data["company.address"] })
          // 13公司电话信息 (company.phone)
          this.$store.commit('setSiteConfig', { showPhone: data["company.phone"] })
          // 14公司小程序二维码 (company.qq)
          this.$store.commit('setSiteConfig', { showMiniapp: data["company.qq"] })
          // 15公司微信二维码 (company.weixin)
          this.$store.commit('setSiteConfig', { showWeixin: data["company.weixin"] })
          // 16公司传真二维码 (company.fax)
          this.$store.commit('setSiteConfig', { showFax: data["company.fax"] })
          // 17网站描述 (site.description)
          this.$store.commit('setSiteConfig', { showDescription: data["site.description"] })
          // 18网站关键词 (site.keywords)
          this.$store.commit('setSiteConfig', { showKeywords: data["site.keywords"] })
        }


        // 1. 检查哀悼模式 (site.gray)
        // const resGray = await getSiteConfig({ key: 'site.gray' })
        // if (resGray.code === 0 && resGray.msg === '1') {
        //   document.documentElement.classList.add('mourning-mode')
        // } else {
        //   document.documentElement.classList.remove('mourning-mode')
        // }

        // 2. 检查显示浏览量 (site.showVisits)
        // const resVisits = await getSiteConfig({ key: 'site.showVisits' })
        // if (resVisits.code === 0) {
        //   this.$store.commit('setSiteConfig', { showVisits: resVisits.msg })
        // }

        // 2. 检查显示外部数据 (site.showExtData)
        // const resExtData = await getSiteConfig({ key: 'site.showExtData' })
        // if (resExtData.code === 0) {
        //   this.$store.commit('setSiteConfig', { showExtData: resExtData.msg })
        // }

        // 2. 检查显示地图 (site.map)
        // const resMap = await getSiteConfig({ key: 'site.map' })
        // if (resMap.code === 0) {
        //   this.$store.commit('setSiteConfig', { showMap: resMap.msg })
        // }


         // 2. 页脚信息 (site.footer)
        // const resFooter = await getSiteConfig({ key: 'site.footer' })
        // if (resFooter.code === 0) {
        //   this.$store.commit('setSiteConfig', { showFooter: resFooter.msg })
        // }


         // 2.站点备案信息 (site.record)
        // const resRecord = await getSiteConfig({ key: 'site.record' })
        // if (resRecord.code === 0) {
        //   this.$store.commit('setSiteConfig', { showRecord: resRecord.msg })
        // }

         // 2.网站logo信息 (site.logo)
        // const resLogo = await getSiteConfig({ key: 'site.logo' })
        // if (resLogo.code === 0) {
        //   this.$store.commit('setSiteConfig', { showLogo: resLogo.msg })
        // }

        //站点标题（site.title）
        //  const resTitle = await getSiteConfig({ key: 'site.title' })
        // if (resTitle.code === 0) {
        //   this.$store.commit('setSiteConfig', { showTitle: resTitle.msg })
        // }

        // 2.网站logo信息 (site.logo)
        // const resTemplate = await getSiteConfig({ key: 'site.template' })
        // if (resTemplate.code === 0) {
        //   this.$store.commit('setSiteConfig', { showTemplate: resTemplate.msg })
        // }

        // 公司邮箱信息 (company.email)
        // const resEmail = await getSiteConfig({ key: 'company.email' })
        // if (resEmail.code === 0) {
        //   this.$store.commit('setSiteConfig', { showEmail: resEmail.msg })
        // }

        // 工作时间 (company.other)
        // const resOther = await getSiteConfig({ key: 'company.other' })
        // if (resOther.code === 0) {
        //   this.$store.commit('setSiteConfig', { showOther: resOther.msg })
        // }

        // 公司地址信息 (company.address)
        // const resAddress = await getSiteConfig({ key: 'company.address' })
        // if (resAddress.code === 0) {
        //   this.$store.commit('setSiteConfig', { showAddress: resAddress.msg })
        // }

        // 公司电话信息 (company.phone)
        // const resPhone = await getSiteConfig({ key: 'company.phone' })
        // if (resPhone.code === 0) {
        //   this.$store.commit('setSiteConfig', { showPhone: resPhone.msg })
        // }

        // 公司小程序二维码 (company.qq)
        // const resMiniapp = await getSiteConfig({ key: 'company.qq' })
        // if (resMiniapp.code === 0) {
        //   this.$store.commit('setSiteConfig', { showMiniapp: resMiniapp.msg })
        // }

         // 公司微信二维码 (company.weixin)
        // const resWeixin = await getSiteConfig({ key: 'company.weixin' })
        // if (resWeixin.code === 0) {
        //   this.$store.commit('setSiteConfig', { showWeixin: resWeixin.msg })
        // }

         // 公司传真二维码 (company.fax)
        // const resFax = await getSiteConfig({ key: 'company.fax' })
        // if (resFax.code === 0) {
        //   this.$store.commit('setSiteConfig', { showFax: resFax.msg })
        // }
        
      } catch (error) {
        console.error('获取站点配置失败:', error)
      }
    },
    updateMetaTag(name, content) {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      if (content) {
        meta.setAttribute('content', content);
      }
    }
  },
  watch: {
    '$store.state.siteConfig.showTitle': {
      handler(val) {
        if (val) {
          // 如果当前路由有标题，合并显示
          const pageTitle = this.$route.meta && this.$route.meta.title;
          document.title = pageTitle ? `${pageTitle} - ${val}` : val;
        }
      },
      immediate: true
    },
    '$store.state.siteConfig.showDescription': {
      handler(val) {
        this.updateMetaTag('description', val);
      },
      immediate: true
    },
    '$store.state.siteConfig.showKeywords': {
      handler(val) {
        this.updateMetaTag('keywords', val);
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

#app {
  height: 100%;
}

.app-container {
  min-height: 100%;
}

.app-main {
  background-color: #f5f7fa;
  min-height: calc(100vh - 78px);
  padding: 0;
}

@media (max-width: 768px) {
  .app-main {
    padding: 10px;
  }
}

/* 哀悼模式全局滤镜 */
.mourning-mode {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
}

/* 回到顶部按钮定制样式 */
.site-backtop {
  width: 44px !important;
  height: 44px !important;
  background-color: #1a3a5c !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
  color: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s !important;
  border-radius: 50% !important;
  
  i {
    font-size: 20px;
    font-weight: bold;
  }
  
  &:hover {
    background-color: #1e3a5f !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(-3px);
  }
}

/* =========================================
   全局响应式基础样式 (Responsive Base Styles)
   ========================================= */

/* 通用响应式图片 */
.responsive-img {
  max-width: 100%;
  height: auto;
}

/* ===== PC端及以上 ===== */
@media (min-width: 992px) {
  .responsive-container {
    width: 1200px;
    margin: 0 auto;
  }
}

/* ===== 平板端 (Tablet) ===== */
@media (min-width: 1001px) and (max-width: 1200px) {
  .responsive-container {
    width: 100%;
    padding: 0 20px;
  }
  
  /* 调整弹窗宽度 */
  .el-dialog {
    width: 75% !important;
  }
  
  html, body {
    font-size: 15px; /* 略微缩小基础字体 */
  }
}

/* ===== 手机与平板端 (Mobile & Tablet) ===== */
@media (max-width: 1000px) {
  .responsive-container {
    width: 100%;
    padding: 0 15px;
  }
  
  /* 手机端应用主容器去留白 */
  .app-main {
    padding: 0;
  }
  
  /* 全局调整弹窗宽度至 90% */
  .el-dialog {
    width: 90% !important;
  }
  
  /* 调整卡片边距，减少浪费空间 */
  .el-card__body {
    padding: 15px !important;
  }
  
  /* 表格在小屏幕出现滚动条而非挤压 */
  .el-table {
    overflow-x: auto;
  }
  
  /* 分页组件小屏适配 */
  .el-pagination {
    white-space: normal !important;
    text-align: center;
    .el-pagination__jump, .el-pagination__sizes, .el-pagination__total {
      display: none !important; /* 隐藏非必要的分页元素 */
    }
  }

  html, body {
    font-size: 14px; /* 移动端基础字体 */
  }

  /* 增加触摸区域高度 */
  .el-button, .el-input__inner {
    min-height: 36px;
  }
}
</style>
